 
import axios from 'axios'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import {
  getResidentContacts,
  getContactUnits,
  updateOwner,
  getOtherContacts,
  getBoardContacts,
  getBoardContact,
  deleteBoardContact,
  updateBoardContact,
  addBoardContact,
} from 'shared/api/client.api'
import { IClient } from 'shared/models/Client'
import { getActiveClient } from 'shared/store/clients/selectors'
import {
  CONTACTS_FETCH_RESIDENTS_ERROR,
  CONTACTS_FETCH_RESIDENTS_REQUESTED,
  CONTACTS_FETCH_RESIDENTS_SUCCESS,
  CONTACT_UNITS_FETCH_ERROR,
  CONTACT_UNITS_FETCH_REQUESTED,
  CONTACT_UNITS_FETCH_SUCCESS,
  CONTACT_UPDATE_ERROR,
  CONTACT_UPDATE_REQUESTED,
  CONTACT_UPDATE_SUCCESS,
  CONTACTS_FETCH_OTHERS_ERROR,
  CONTACTS_FETCH_OTHERS_REQUESTED,
  CONTACTS_FETCH_OTHERS_SUCCESS,
  CONTACTS_FETCH_BOARDCONTACTS_REQUESTED,
  CONTACTS_FETCH_BOARDCONTACTS_ERROR,
  CONTACTS_FETCH_BOARDCONTACTS_SUCCESS,
  CONTACTS_FETCH_BOARDCONTACT_REQUESTED,
  CONTACTS_FETCH_BOARDCONTACT_ERROR,
  CONTACTS_FETCH_BOARDCONTACT_SUCCESS,
  CONTACTS_MANAGE_BOARDCONTACT_REQUESTED,
  CONTACTS_MANAGE_BOARDCONTACT_SUCCESS,
  CONTACTS_MANAGE_BOARDCONTACT_ERROR,
} from './actionTypes'
import { ContactsActionTypes } from './types'

function* fetchResidentContacts(action: ContactsActionTypes) {
  try {
    const client: IClient = yield select(getActiveClient)

    const { data } = yield call(
      getResidentContacts,
      client.id,
      action.payload.filters,
      action.payload.source
    )
    yield put({
      type: CONTACTS_FETCH_RESIDENTS_SUCCESS,
      payload: data,
    })
  } catch (e: any) {
    if (!axios.isCancel(e)) {
      console.log(e.response?.data)
      yield put({
        type: CONTACTS_FETCH_RESIDENTS_ERROR,
        payload: e.response?.data || true,
      })
    }
  }
}

function* fetchOtherContacts(action: ContactsActionTypes) {
  try {
    const client: IClient = yield select(getActiveClient)

    const { data } = yield call(
      getOtherContacts,
      client.id,
      action.payload.filters,
      action.payload.source
    )

    yield put({
      type: CONTACTS_FETCH_OTHERS_SUCCESS,
      payload: data,
    })
  } catch (e: any) {
    if (!axios.isCancel(e)) {
      console.log(e.response?.data)
      yield put({
        type: CONTACTS_FETCH_OTHERS_ERROR,
        payload: e.response?.data || true,
      })
    }
  }
}

function* fetchBoardContacts(action: ContactsActionTypes) {
  try {
    const { id } = yield select(getActiveClient)

    const { data } = yield call(
      getBoardContacts,
      id,
      action.payload.filters,
      action.payload?.source
    )

    yield put({
      type: CONTACTS_FETCH_BOARDCONTACTS_SUCCESS,
      payload: data,
    })
  } catch (e: any) {
    if (!axios.isCancel(e)) {
      console.log(e.response?.data)
      yield put({
        type: CONTACTS_FETCH_BOARDCONTACTS_ERROR,
        payload: e.response?.data || true,
      })
    }
  }
}

function* fetchBoardContact(action: ContactsActionTypes) {
  try {
    const { id } = yield select(getActiveClient)

    const { data } = yield call(getBoardContact, id, action.payload)

    yield put({
      type: CONTACTS_FETCH_BOARDCONTACT_SUCCESS,
      payload: data,
    })
  } catch (e: any) {
    console.log(e.response?.data)
    yield put({
      type: CONTACTS_FETCH_BOARDCONTACT_ERROR,
      payload: e.response?.data || true,
    })
  }
}

function* manageBoardContact(action: ContactsActionTypes) {
  try {
    const { id } = yield select(getActiveClient)

    if (action.payload.isDelete)
      yield call(deleteBoardContact, id, action.payload.id)
    else if (action.payload.id)
      yield call(
        updateBoardContact,
        id,
        action.payload.id,
        action.payload.contact
      )
    else yield call(addBoardContact, id, action.payload.contact)

    yield put({
      type: CONTACTS_MANAGE_BOARDCONTACT_SUCCESS,
    })
  } catch (e: any) {
    console.log(e.response?.data)
    yield put({
      type: CONTACTS_MANAGE_BOARDCONTACT_ERROR,
      payload: e.response?.data || true,
    })
  }
}

function* fetchContactUnits(action: ContactsActionTypes) {
  try {
    const client: IClient = yield select(getActiveClient)

    const { data } = yield call(
      getContactUnits,
      client.id,
      action.payload.nameId
    )
    yield put({
      type: CONTACT_UNITS_FETCH_SUCCESS,
      payload: data,
    })
  } catch (e: any) {
    console.log(e.response?.data)
    yield put({
      type: CONTACT_UNITS_FETCH_ERROR,
      payload: e.response?.data || true,
    })
  }
}

function* updateContact(action: ContactsActionTypes) {
  try {
    const client: IClient = yield select(getActiveClient)

    const params = {
      clientId: client.id,
      nameId: action.payload.nameId,
      owner: action.payload.values,
    }
    yield call(updateOwner, params)
    yield put({
      type: CONTACT_UPDATE_SUCCESS,
      payload: { nameId: action.payload.nameId, values: action.payload.values },
    })
  } catch (e: any) {
    console.log(e.response?.data)
    yield put({
      type: CONTACT_UPDATE_ERROR,
      payload: e.response?.data || true,
    })
  }
}

function* communicationsettingsSaga() {
  yield takeEvery(CONTACTS_FETCH_RESIDENTS_REQUESTED, fetchResidentContacts)
  yield takeEvery(CONTACTS_FETCH_OTHERS_REQUESTED, fetchOtherContacts)
  yield takeEvery(CONTACTS_FETCH_BOARDCONTACTS_REQUESTED, fetchBoardContacts)
  yield takeEvery(CONTACTS_FETCH_BOARDCONTACT_REQUESTED, fetchBoardContact)
  yield takeEvery(CONTACTS_MANAGE_BOARDCONTACT_REQUESTED, manageBoardContact)
  yield takeEvery(CONTACT_UNITS_FETCH_REQUESTED, fetchContactUnits)
  yield takeEvery(CONTACT_UPDATE_REQUESTED, updateContact)
}

export default communicationsettingsSaga
